// Entry point — redirects to login or dashboard based on Supabase auth state
'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { createClient } from '@/lib/supabase/client';

export default function RootPage() {
  const router = useRouter();

  useEffect(() => {
    const supabase = createClient();
    supabase?.auth?.getSession()?.then(({ data: { session } }) => {
      if (session) {
        router?.replace('/dashboard');
      } else {
        router?.replace('/sign-up-login-screen');
      }
    });
  }, [router]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-muted-foreground">Loading DVT Minutes Builder</p>
      </div>
    </div>
  );
}